import {
  CButton,
  CCol,
  CContainer,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from "@coreui/react";
import { useState } from "react";
import { Spinner } from "react-bootstrap";
import { deleteItem } from "../../api/generics";
import SystemNotification from "../../models/system-notification";
import { SUCCESS } from "../../utils/constants/tags";
import { errorAlert } from "../utils/messages";

interface SystemNotificationDeleteModalProps {
  show: boolean;
  systemNotification?: SystemNotification;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const SystemNotificationDeleteModal: React.FC<
  SystemNotificationDeleteModalProps
> = ({ show, systemNotification, onCancel, onSuccess }) => {
  const [submitting, setSubmitting] = useState(false);

  const message = systemNotification
    ? `Está seguro de que quiere eliminar el aviso #${systemNotification.id}`
    : "";

  const onDeleteClick = async () => {
    if (systemNotification !== undefined) {
      setSubmitting(true);
      const notificationStatus = await deleteItem<SystemNotification>(
        `/system_notifications/admin/${systemNotification.id}/`,
        systemNotification
      );

      if (notificationStatus.status !== SUCCESS) {
        let message = "Ha ocurrido un error!!";
        if (notificationStatus.detail !== undefined) {
          message = notificationStatus.detail;
        }
        errorAlert(message);
      } else {
        onSuccess();
      }

      setSubmitting(false);
    }
  };

  return (
    <CModal show={show} className="modal-danger" onClosed={onCancel} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>Eliminar</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <CRow>
            <CCol sm="12">
              <h2>{message}</h2>
            </CCol>
          </CRow>
        </CContainer>
      </CModalBody>
      <CModalFooter>
        <CButton disabled={submitting} onClick={onDeleteClick} color="danger">
          {submitting ? (
            <Spinner
              animation="grow"
              style={{
                height: "17px",
                width: "17px",
                marginTop: "auto",
                marginBottom: "auto",
                marginRight: "10px",
              }}
            />
          ) : (
            <></>
          )}
          {submitting ? "Eliminando..." : "Eliminar"}
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default SystemNotificationDeleteModal;
